import React from "react";
import { ReactComponent as Logotype } from "glyphs/logo.svg";
import cx from "classnames";
import cls from "./Logo.module.scss";

const Logo: React.FC<{ className?: string }> = React.memo(({ className }) => (
  <a className={cx(cls.element, className)}>
    <Logotype />
  </a>
));

export default Logo;
